query simpleBasketballTeams($search: String) {
  teams: allBasketballTeams(
    orderBy: NAME_ASC
    first: 20
    filter: { name: { includesInsensitive: $search } }
  ) {
    nodes {
      id: teamId
      name
    }
  }
}
